import PropTypes from 'prop-types';
import React, { Component } from 'react';

import LoginWidget from '@sm360/widget-login';
import { AccountService, Account, ProfileService, ModalService, HistoryService } from '@sm360/widget-commons-general';
import { WindowProxy } from '@sm360/widget-commons-core-services';

class LoginStep extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accountLoading: false,
            account: props.account,
        };

        this.initModal = this.initModal.bind(this);
        this.onLogin = this.onLogin.bind(this);
        if (!props.isRenderedInModal) {
            this.initModal();
        }
    }

    componentWillMount() {
        function loadAccount() {
            return ProfileService.getLoggedAccountProfile().then((account) =>
                this.setState({ accountLoading: false, account: new Account(account) }, () =>
                    this.props.stepDone(this.state.account)
                )
            );
        }

        if (AccountService.isAuthenticated() && !this.state.account) {
            this.setState({ accountLoading: true }, loadAccount);
        } else if (this.state.account) {
            this.props.stepDone();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.isRenderedInModal && !this.modal) {
            this.initModal();
        }
    }

    onLogin() {
        if (!AccountService.isAuthenticated()) {
            const windowProxy = WindowProxy.get();
            if (windowProxy) {
                HistoryService.goBackOrHome();
            }
            return this.props.stepDone();
        }
        return ProfileService.getLoggedAccountProfile().then((account) => this.props.stepDone(new Account(account)));
    }

    initModal() {
        this.modal = ModalService.get('login/SignUpModal');
        this.modal.addCallbacks({ onClose: this.onLogin });
    }

    render() {
        if (!AccountService.isAuthenticated() && !this.state.account && !this.state.accountLoading) {
            if (this.props.isRenderedInModal) {
                return <LoginWidget.GuestOrSignin onSuccess={this.onLogin} />;
            }
            this.modal.open();
        }
        return null;
    }
}

LoginStep.defaultProps = {
    account: null,
};

LoginStep.propTypes = {
    account: PropTypes.instanceOf(Account),
    isRenderedInModal: PropTypes.bool.isRequired,
    stepDone: PropTypes.func.isRequired,
};

LoginStep.displayName = 'LoginStep';

export default LoginStep;
